// JS
import React, { useEffect, useState } from 'react';
import { randomId } from '../shared/utils';
import { Skeleton } from '../Ui/skeleton';

// COMPONENTS
import BrandFocusHero from '../BrandFocusHero';
import Slider from '../Slider';
import Product from '../Product';
import Button from '../Button';

// COMPONENT
const BrandFocus = ({
  brandFocusData,
  brandFocusFeed,
  heroGaBlockName,
  carouselGaBlockName,
  showBrandFocus = true,
  brandFocusOptions
}) => {
  const uniqueId = randomId();
  const [data, setData] = useState(brandFocusFeed);

  // API DATA
  useEffect(() => {
    if (brandFocusFeed && brandFocusFeed.data) {
      setData(brandFocusFeed.data.products.products);
    }
  }, [brandFocusFeed]);

  return (
    <section
      id={'brand-focus-section-' + uniqueId}
      className={
        showBrandFocus
          ? 'container my-24 lg:my-48' +
            (brandFocusOptions?.classes ? ' ' + brandFocusOptions.classes : '')
          : 'hidden'
      }
    >
      {brandFocusData ? (
        brandFocusData.map((item, i) => {
          return (
            <React.Fragment key={i}>
              <BrandFocusHero
                gaBlockName={heroGaBlockName}
                item={item}
                productPosition={i + 1}
              />

              <div className="md:pt-5">
                {data && (
                  <Slider
                    name="brand-focus-section-slider"
                    className="md:pt-5"
                    responsive={{
                      sm: { show: 1, spaceBetween: 10 },
                      lg: { show: 3 },
                      xl: { show: 4, spaceBetween: 12 }
                    }}
                    usePagination={true}
                    paginationOptions={{
                      rounded: true,
                      noContain: true,
                      classes: {
                        wrapper: '!justify-start !mt-1 md:hidden'
                      }
                    }}
                  >
                    {data.map((slide, i) => (
                      <Product
                        key={'product-key-' + uniqueId}
                        gaBlockName={carouselGaBlockName}
                        productID={slide.product.productid}
                        productURL={slide.product.url}
                        productName={slide.product.name}
                        productPosition={i + 1}
                        productCategory={
                          slide.product.attributes.product_category
                        }
                        productBrand={slide.product.attributes.brand}
                        productImage={slide.product.image}
                        productImageAlternate={
                          slide.product.attributes.alternative
                        }
                        productPrice={slide.product.option.price}
                        productPromotionPrice={
                          slide.product.option.promotionprice
                        }
                        productAspectOptions={{
                          classes: 'lg:aspect-h-11'
                        }}
                      />
                    ))}
                  </Slider>
                )}

                <Button
                  buttonColour="black"
                  buttonGroup={false}
                  buttonLink={item.url}
                  buttonLinkText={item.link_label}
                  buttonAdditionalClasses={{
                    classes: 'mt-7 md:hidden'
                  }}
                  gaBlockTitle={item.link_label}
                  gaBlockName={heroGaBlockName}
                  gaBlockId={item.contentguid}
                />
              </div>
            </React.Fragment>
          );
        })
      ) : (
        <Skeleton className="aspect-square w-[100%] h-[500px]" />
      )}
    </section>
  );
};

export default BrandFocus;
